/**
 * Release version (#900)
 *
 * Reads `release.json`, written at build time by
 * `scripts/release/write-release-info.mjs` from `RELEASE_TAG`. Imported
 * rather than read from disk so it also works in the Edge middleware.
 * Only UAT and Production builds have a version; everything else is null.
 */

import releaseInfo from './release.json';

export type ReleaseEnvironment = 'uat' | 'production';

export interface ReleaseInfo {
  version: string | null;
  environment: ReleaseEnvironment | null;
}

export const RELEASE_VERSION_HEADER = 'X-Release-Version';

const RELEASE_TAG_RE = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(-rc\.[1-9]\d*)?$/;

/** Returns the release info, discarding anything that is not a valid tag. */
export function getReleaseInfo(info: { version: unknown; environment: unknown } = releaseInfo): ReleaseInfo {
  const { version, environment } = info;
  if (typeof version !== 'string' || !RELEASE_TAG_RE.test(version)) {
    return { version: null, environment: null };
  }
  return {
    version,
    environment: environment === 'uat' || environment === 'production' ? environment : null,
  };
}

export function getReleaseVersion(): string | null {
  return getReleaseInfo().version;
}
